/**
 * CAPITAL GAINS TAX ON A HOME KEPT AND RENTED OUT — said in every "Explain this" for such a plan, whatever the years
 * planned (owner, 22 Oct 2026: "even if they still model only for 5 years the clients need to be aware of this.
 * Ultimately the projection period is just a period.. we dont know how long the clients will realistically live").
 *
 * The estate figure already nets the tax (estateCgtOnRentedHome): nil while the home has been let six years or less,
 * then the share of the gain beyond six years. This note says the rule, and whether the years planned reach it.
 */
import React from 'react';

export interface RentedHomeCgtNoteProps {
    /** The years the plan's estate figure looks ahead. */
    horizonYears: number;
    /** "you" / "they" for the household (householdVoice). */
    they?: string;
    testId?: string;
}

export function rentedHomeCgtWords(horizonYears: number, they = 'they'): string[] {
    const within = horizonYears <= 6;
    return [
        'While the home is let, it stays free of capital gains tax for up to six years from when it is first rented out, as long as no other home is treated as the main residence. After six years, part of the gain is taxed when it is sold, including when the family sells it after a death.',
        within
            ? `The ${horizonYears} ${horizonYears === 1 ? 'year' : 'years'} planned are inside the six, so the figure left to the family has no tax taken off for it. But nobody knows how long ${they} will live or need care: if the home is still let after six years, some of the gain will be taxed, and the longer it is let the more of it is.`
            : `The ${horizonYears} years planned go past the six, so the figure left to the family already takes off the tax on the part of the gain beyond six years. The longer the home is let, the more of the gain is taxed.`,
    ];
}

export const RentedHomeCgtNote = ({ horizonYears, they = 'they', testId = 'rented-home-cgt' }: RentedHomeCgtNoteProps) => (
    <div className="mt-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700" data-testid={testId}>
        <p className="font-bold text-slate-900">Capital gains tax on the home</p>
        {rentedHomeCgtWords(horizonYears, they).map((w, i) => <p key={i} className="mt-1">{w}</p>)}
    </div>
);

export default RentedHomeCgtNote;
